/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

! function() {
    "use strict";

    angular.module('webReader').service('DocumentService', constructor);

    function constructor(HashService, DocumentModel, $cookieStore, $interval, localStorageService, $timeout) {
        var self = this;
        var cookieStore = $cookieStore;
        var documentHeight = 0;
        var onDocHeightChange = [];
        var onProgressUpdate = [];
        var onDocScrollRequestedCallback = [];
        var onChapterRendered = {};
        var onColorThemeUpdateCallback = [];
        var onSpinnerStateChangeRequest = [];
        var pagesCount = 0;
        var currentChapterPath;
        var scrollPosition = 0;
        var chaptersBookmarks = {};
        var navigationMode;
        var cfiBookmarks;
        var currentBookOffset = 0;
        var isFavorite = false;
        var pages = { current: 0, total: 0 };
        var onStatusScrollCreated = [];
        var statusScrollCreated;

        self.create = function() {
            var documentPath;

            HashService.create();

            if (HashService.getHashParameters()['access_token']) {
                cookieStore.put('accessToken', HashService.getHashParameters()['access_token']);
                cookieStore.put('refreshToken', HashService.getHashParameters()['refresh_token']);
                cookieStore.put('path', HashService.getHashParameters()['path']);
            }

            DocumentModel.create(cookieStore.get('path'));
            DocumentModel.invoke().then(function(data) {
                self.updateFavorite(!!data.favorite);
            });
        };

        self.updateDocumentHeight = function(deltaHeight) {
            console.log('updateDocumentHeight',deltaHeight);
            $timeout(function() {
                documentHeight = angular.element('content-wrapper').height();
                DocumentModel.updateWrapperHeight(documentHeight);
                self.executeSubscriptions.call(this, onDocHeightChange, { deltaHeight: deltaHeight });
            }, 100);
        };

        self.recalculateDocumentHeight = function() {
            documentHeight = angular.element('content-wrapper').height();
        };

        self.setChapterRendered = function(chapterId) {
            DocumentModel.setChapterRendered(chapterId);
            onChapterRendered[chapterId] && self.executeSubscriptions.call(this, onChapterRendered[chapterId], []);
        };

        self.scrollDocumentToChapter = function(chapterUrl, cfiPositionString) {
            self.executeSubscriptions.call(this, onDocScrollRequestedCallback, [{ chapterUrl: chapterUrl, cfiPositionString: cfiPositionString }]);
        };

        self.getTotalDocumentHeightByFormat = {
            'epub': function() {
                // console.warn('EPUB: doc height',angular.element('content-wrapper').height());
                // console.warn('EPUB: content length by files.length from server ',DocumentModel.getTotalContentLength());
                // console.warn('EPUB: loaded content length by files.length from server ',DocumentModel.getLoadedContentLength());

                return angular.element('content-wrapper').height() * DocumentModel.getTotalContentLength() / DocumentModel.getLoadedContentLength();
            },
            'pdf': function() {
                return angular.element('content-wrapper').height() * DocumentModel.getTotalContentLength() / DocumentModel.getLoadedContentLength();
            }
        };

        self.getTotalDocumentHeight = function() {
            return self.getTotalDocumentHeightByFormat[DocumentModel.getDocumentFormat()]();
        };

        self.getLoadedDocumentHeight = function() {
            self.recalculateDocumentHeight();
            return documentHeight;
        };

        self.getBookOffset = function() {
            return localStorageService.get(cookieStore.get('path') + '.readPosition') || null;
        };

        self.parseCfiPosition = function(sourceString) {
            var cfi_position = sourceString.match(/\/\d+/ig);
            var charCfiPosition = sourceString.match(/\:\d+/ig);

            if (sourceString.indexOf('epubcfi') >= 0 && cfi_position.length > 1) {
                // console.log(cfi_position);
                _.map(cfi_position, function(el, i, collection) {
                    el = parseInt(el.replace('/', ''));
                    //el = Math.ceil(el/2) - 1;
                    collection[i] = el;
                });

                if (!!charCfiPosition) {
                    cfi_position = cfi_position.concat(charCfiPosition);
                }

                return ((cfi_position[1] / 2 - 1) >= DocumentModel.getDocumentInformation().length) ? null : {
                    url: DocumentModel.getChapterUrlById(cfi_position[1] / 2 - 1),
                    offsetChar: cfi_position,
                    pOffset: 0
                };
            } else {
                return null;
            }
        };

        self.getInitialBookPositionCollection = {
            'epub': function() {
                //try to parse "position" in metadata
                var documentPosition = DocumentModel.getDocumentBaseInformation().position;
                var position = _.isObject(documentPosition) ? documentPosition.pointer || documentPosition.pointer_pb : '';
                // console.warn('POSITION', position)
                var cfi_position;

                //position = "pbl:OEBPS/section85.xhtml?offs=60211";
                //position = "#epubcfi(/6/4!/4/2[Carroll_Alice-1.html]/2/6/1:179)";

                if (position.indexOf('epubcfi') >= 0) {
                    return self.parseCfiPosition(position);
                } else {
                    position = /pbl:([^\?]+)\?offs=(\d+)(&pixelsTop=(\d+)){0,1}/ig.exec(position);
                    if (position && position.length >= 3) {
                        navigationMode = 'pbl';
                        return {
                            url: position[1],
                            offsetChar: position[2],
                            pOffset: _.isUndefined(position[4]) ? 0 : position[4]
                        };
                    } else {
                        return null;
                    }
                }
            },
            'pdf': function() {
                var documentPosition = DocumentModel.getDocumentBaseInformation().position;
                var position = _.isObject(documentPosition) ? documentPosition.pointer_pb || documentPosition.pointer : '';
                //var position = /[^,]+(\d+)/ig.exec(documentPosition);//regex for pointer of pb
                var position;

                if (position.indexOf('#pdfloc') >= 0) {
                    position = /[^\d]+(\d+)[^\d]+(\d+)/ig.exec(position);
                    position[2] = 0;
                    position[3] = 0;
                } else {
                    position = /[^\d]+(\d+)[^\d]+(\d+)[^\d]+(\d+)/ig.exec(position);
                }

                if (!_.isArray(position) || position.length < 4) {
                    position = [0, 0, 0, 0];
                }

                return {
                    url: DocumentModel.getDocumentBaseInformation().files[position[1]].url,
                    offsetChar: position[2],
                    pixelsTop: position[3]
                }
            }
        };

        self.getInitialBookPosition = function() {
            return self.getInitialBookPositionCollection[DocumentModel.getDocumentFormat()]();
        };

        self.getChapterObjectOffsetByFormat = {
                'epub': function(position, initialChapter) {
                    var initialChapterStatus = DocumentModel.getChapterStatus(initialChapter);
                    var chapterOffsetObject = self.getChapterOffsetObject(position.offsetChar, initialChapter);
                    if (initialChapterStatus && initialChapterStatus === 'LOADED' && !!chapterOffsetObject) {
                        var targetElement;

                        if (!!chapterOffsetObject.targetElement) {
                            targetElement = $('[name=content-mark-' + chapterOffsetObject.targetElement.uniqNavMark + ']');
                        } else {
                            targetElement = chapterOffsetObject.element;
                        }
                        //@toDo: remove .content-mark elements at this line of code

                        return (!!angular.element(targetElement).position()) ? (-angular.element(targetElement).position().top + parseInt(position.pOffset)) : 0;
                    } else {
                        return false;
                    }
                },
                'pdf': function(position, initialChapter) {
                    var initialChapterStatus = DocumentModel.getChapterStatus(initialChapter);
                    var chapterOffsetObject = angular.element('.' + DocumentModel.getDocumentBaseInformation().files[initialChapter].style);
                    if (initialChapterStatus && initialChapterStatus === 'LOADED' && !!chapterOffsetObject) {
                        return -chapterOffsetObject.position().top - position.pixelsTop;
                    } else {
                        return false;
                    }
                }
            },
            self.getInitialChapterOffset = function() {
                var initialPosition = self.getInitialBookPosition();
                var initialChapter, initialChapterStatus, chapterOffsetObject;
                // console.error('initialPosition',initialPosition);
                if (!initialPosition) {
                    return 0;
                } else {
                    initialChapter = DocumentModel.getChapterIdByUrl(initialPosition.url);
                }

                return self.getChapterObjectOffsetByFormat[DocumentModel.getDocumentFormat()](initialPosition, initialChapter);
            };

        self.getUniqNavMark = (function() {
            var lastUniqNavNumber = 0;

            return function() {
                return lastUniqNavNumber++;
            };
        })(self);

        //invert selection - select text from a beginning
        self.getChapterOffsetObject = function(offsetChar, chapterId, invertSelection, uniqNavMark, selectionEnd) {
            console.log('### ### ### GET ELEMENT TO OFFSET')
            console.log('CFI (array) ', offsetChar)
            console.log('Chapter id ', chapterId)
            //todo: !getPosition what is uniqNavMark?
            var _uniqNavMark = uniqNavMark;
            var chapterUrl = DocumentModel.getChapterUrlById(chapterId);
            if (_.isArray(offsetChar) && _.isNumber(uniqNavMark)) {
                if (DocumentModel.checkIf.isChapterRendered(chapterId)) {
                    var chapterOffsetObject;
                    var chapterInfoObject = DocumentModel.getChapterByIndex(chapterId);
                    var bookmarks = $('div.' + chapterInfoObject.style + ' > div:first-child').children();

                    var getCfiBookmarkObject = function(position, parentBookmark, endPosition) {

                        var mark, endMark;
                        var maxDeep = !_.isNumber(position[position.length - 1]) ? position.length - 2 : position.length;
                        var endMaxDeep = (!!endPosition) ? (!_.isNumber(endPosition[endPosition.length - 1]) ? endPosition.length - 2 : endPosition.length) : null;
                        var markElement = {};
                        var endMarkElement = {};

                        if (position[3] % 2) {} else {
                            mark = $(parentBookmark[Math.ceil(position[3] / 2) - 1]);

                            if (!!endPosition) {
                                endMark = $(parentBookmark[Math.ceil(endPosition[3] / 2) - 1]);
                            }

                            for (var i = 4; i < maxDeep && !(position[i] % 2) && mark.children().length && mark.children()[Math.ceil(position[i] / 2) - 1]; i++) {
                                mark = $(mark.children()[Math.ceil(position[i] / 2) - 1]);
                            }

                            if (!!endPosition) {
                                for (var j = 4; j < endMaxDeep && !(endPosition[j] % 2) && endMark.children().length && endMark.children()[Math.ceil(endPosition[j] / 2) - 1]; j++) {
                                    endMark = $(endMark.children()[Math.ceil(endPosition[j] / 2) - 1]);
                                }
                            }

                            if (i < position.length) {
                                //inserting cover span element
                                var updatedElementHTMLContent = '';

                                if (position[i] - 1 < mark[0].childNodes.length) {
                                    //take child node in a content
                                    markElement.element = mark[0].childNodes[position[i] - 1];
                                    markElement.targetElement = {
                                        node: mark,
                                        // offsetChars: position[position.length - 1],
                                        uniqNavMark: _uniqNavMark
                                    };

                                    if (!!endPosition) {

                                        endMarkElement.element = endMark[0].childNodes[endPosition[j] - 1];
                                        var htlEndMark = $(endMarkElement.element).html();
                                        endMarkElement.targetElement = {
                                            endPosition: $(endMarkElement.element).text().trim().length,
                                            elementNodeText: $(endMarkElement.element).text(),
                                            node: endMark
                                        };
                                        endMarkElement.endMarkHtml = endMark.html().substr(endMark.html().indexOf(endMarkElement.targetElement.elementNodeText.substr(0, endMarkElement.targetElement.endPosition)) + endMarkElement.targetElement.endPosition);
                                    }

                                    //and after that increment i
                                    i += 1;
                                    j += 1;
                                    //if position[i] exists, then cover part of text with span
                                    if (i < position.length) {
                                        var sourceHTML = markElement.targetElement.node.html();
                                        var startPosition = (!!invertSelection) ? 0 : parseInt(position[i].substr(1));
                                        var endSelection = (!!endPosition) ? sourceHTML.indexOf(endMarkElement.endMarkHtml) + endMarkElement.endMarkHtml.length : (!!invertSelection) ? parseInt(position[i].substr(1)) : undefined;
                                        var sourceText = markElement.element.data || $(markElement.element).text();


                                        if (!!startPosition) {
                                            sourceHTML = sourceHTML.replace(sourceText.substring(0, startPosition), sourceText.substring(0, startPosition) + '<span class="content-mark" name="content-mark-' + markElement.targetElement.uniqNavMark + '">');
                                        } else {
                                            sourceHTML = '<span class="content-mark" name="content-mark-' + markElement.targetElement.uniqNavMark + '">' + sourceHTML;
                                        }

                                        if (!!endSelection) {
                                            if (!!endPosition) {
                                                sourceHTML = sourceHTML.replace(endMarkElement.endMarkHtml, '</span>' + endMarkElement.endMarkHtml);
                                            } else {
                                                sourceHTML = sourceHTML.replace(sourceText.substring(0, endSelection) || sourceText, (sourceText.substring(0, endSelection) || sourceText) + '</span>');
                                            }
                                            //updatedElementHTMLContent += sourceText.substring(endSelection);
                                        } else {
                                            sourceHTML = sourceHTML + '</span>';
                                        }
                                        $(markElement.targetElement.node).html(sourceHTML);
                                    } else {
                                        //otherwise cover child node with span
                                        var sourceText = markElement.element.data || $(markElement.element).text();
                                        updatedElementHTMLContent = '<span class="content-mark" name="content-mark-' + markElement.targetElement.uniqNavMark + '">' + $(markElement.targetElement.node).html() + '</span>';
                                        $(markElement.targetElement.node).html(updatedElementHTMLContent);

                                    }
                                } else {
                                    markElement.element = mark[0];
                                    markElement.targetElement = {
                                        node: mark[0],
                                        //offsetChars: position[position.length-1],
                                        uniqNavMark: _uniqNavMark
                                    };
                                    var sourceText = markElement.element.data || $(markElement.element).text();
                                    updatedElementHTMLContent = '<span class="content-mark" name="content-mark-' + markElement.targetElement.uniqNavMark + '">' + $(markElement.targetElement.node).html() + '</span>';
                                    $(markElement.targetElement.node).html(updatedElementHTMLContent);

                                }
                            } else {
                                markElement.targetElement = {
                                    node: mark[0],
                                    //offsetChars: position[position.length-1],
                                    uniqNavMark: _uniqNavMark
                                };
                                $(markElement.element).addClass('content-mark').attr('name', 'content-mark-' + markElement.targetElement.uniqNavMark);
                            }

                            return markElement;
                        }
                    };

                    if (offsetChar.length > 3 && !!bookmarks[Math.ceil(offsetChar[3] / 2) - 1]) {
                        // console.log(offsetChar, bookmarks, selectionEnd)
                        return getCfiBookmarkObject(offsetChar, bookmarks, selectionEnd);
                    } else {
                        return bookmarks[0];
                    }
                } else {
                    return false;
                }
            } else if (_.isArray(offsetChar)) {
                if (DocumentModel.checkIf.isChapterRendered(chapterId)) {
                    var chapterOffsetObject;
                    var chapterInfoObject = DocumentModel.getChapterByIndex(chapterId);
                    console.log('Chapter info', chapterInfoObject)
                    var bookmarks = $('div.' + chapterInfoObject.style + ' > div:first-child').children();
                    var getCfiBookmarkRefObject = function(position, parentBookmark) {
                        // debugger
                        var mark;
                        //todo: !getPosition if preLast element of CFI (array) is not number then maxDeep is -2 of length
                        var maxDeep = !_.isNumber(position[position.length - 1]) ? position.length - 2 : position.length;
                        console.log('maxDeep (если предпоследний элемент CFI (array) не число то maxDeep = (длина массива-2), иначе длина массива)', maxDeep)
                        var markElement = {};

                        if (position[3] % 2) {} else {
                            console.log('если CFI[3] % 2 === 0')
                        //todo: !getPosition if cfi[3] divide on 2 get 0 =>
                            //todo: !getPosition get chapter's html
                            mark = $(parentBookmark[Math.ceil(position[3] / 2) - 1]);
                            console.log('Chapter HTML',mark);
                            //todo: !getPosition if cfi[4+] not (divide on 2 get 0)
                            window.mark = mark;
                            console.log('for i=4 to maxDeep', 'И если i%2 !== 0 и если есть массив потомков у Chapter HTML');
                            for (var i = 4; i < maxDeep && !(position[i] % 2) && mark.children().length && mark.children()[Math.ceil(position[i] / 2) - 1]; i++) {

                                mark = $(mark.children()[Math.ceil(position[i] / 2) - 1]);
                console.log('Chapter HTML (массив потомков Chapter HTML под номером (округление в большую сторону (CFI[i] / 2)) -1 ) = ', mark);
                            }
                            return { element: mark };
                        }
                    };

                    if (offsetChar.length > 3 && !!bookmarks[Math.ceil(offsetChar[3] / 2) - 1]) {
                        return getCfiBookmarkRefObject(offsetChar, bookmarks);
                    } else {
                        return bookmarks[0];
                    }
                } else {
                    var bookmarkUrlCollection = _.keys(chaptersBookmarks[chapterId])
                    // console.log('this else work bookmarkUrlCollection', bookmarkUrlCollection);
                    return false;
                }
            } else {
                var bookmarkUrlCollection = _.keys(chaptersBookmarks[chapterId]);
                var chapterOffsetObject;
                var chapterBookmarkCollection = chaptersBookmarks[chapterId];
                var bookmarks = _.keys(chapterBookmarkCollection.marks);

                for (var j = 0; j < bookmarks.length && parseInt(bookmarks[j]) < parseInt(offsetChar); j++) {};

                if (j < bookmarks.length) {
                    return chapterBookmarkCollection.marks[bookmarks[j]];
                } else {
                    return false;
                }
            }
        };

        self.getSelectionObjectsCollection = function(selection) {
            var resultCollection = [];
            var startChapterId = DocumentModel.getChapterIdByUrl(selection.position.start_pointer.url);
            var endChapterId = DocumentModel.getChapterIdByUrl(selection.position.end_pointer.url);
            var uniqNavMark = self.getUniqNavMark();
            var middleCollection;
            var maxCompareIndex;

            if (_.isString(selection.position.start_pointer.offsetChar[selection.position.start_pointer.offsetChar.length - 1])) {
                maxCompareIndex = selection.position.start_pointer.offsetChar.length - 3;
                maxCompareIndex = Math.min(maxCompareIndex, selection.position.end_pointer.offsetChar.length - 1);
            } else {
                maxCompareIndex = selection.position.start_pointer.offsetChar.length - 1;
                maxCompareIndex = Math.min(maxCompareIndex, selection.position.end_pointer.offsetChar.length - 1);
            }

            for (; maxCompareIndex >= 0 && selection.position.start_pointer.offsetChar[maxCompareIndex] === selection.position.end_pointer.offsetChar[maxCompareIndex]; maxCompareIndex--) {};

            if (maxCompareIndex < 0) {
                //selection started and finished within same dom child
                // console.log('getSelectionObjectsCollection service', selection.position.start_pointer.offsetChar, startChapterId, uniqNavMark, selection.position.end_pointer.offsetChar)
                resultCollection.push(self.getChapterOffsetObject(selection.position.start_pointer.offsetChar, startChapterId, false, uniqNavMark, selection.position.end_pointer.offsetChar));
            } else {
                //selection started and finished in different dom children
                resultCollection.push(self.getChapterOffsetObject(selection.position.start_pointer.offsetChar, startChapterId, false, uniqNavMark));
                resultCollection.push(self.getChapterOffsetObject(selection.position.end_pointer.offsetChar, endChapterId, true, uniqNavMark));
                middleCollection = self.getCFIBookmarkRangeCollection(selection.position.start_pointer, selection.position.end_pointer, uniqNavMark);
                self.markCollection(middleCollection);

                resultCollection = resultCollection.slice(0, 1);
                if (!!middleCollection) {
                    resultCollection = resultCollection.concat(middleCollection, resultCollection.slice(-1));
                }
            }
            return resultCollection;
        };

        self.markCollection = function(elementCollection, uniqNavMark) {
            var _uniqNavMark = uniqNavMark;

            _.map(elementCollection, function(el, index, collection) {
                collection[index] = {
                    element: el,
                    targetElement: {
                        node: el,
                        uniqNavMark: _uniqNavMark
                    }
                };
                // console.log(uniqNavMark);
                $(collection[index].element).addClass('content-mark').attr('name', 'content-mark-' + _uniqNavMark);
            });
        };

        //cfi1, cfi2 - >
        //offsetChar: [], url: ''
        //output = [{ chapterId, children, element, uniqNavMark}, ...]
        self.getCFIBookmarkRangeCollection = function(cfi1, cfi2) {
                var result = [];
                var startChapter = DocumentModel.getChapterIdByUrl(cfi1.url);
                var endChapter = DocumentModel.getChapterIdByUrl(cfi2.url);
                var chapterBookmarkCollection = cfiBookmarks[startChapter];
                var bookmarks = chapterBookmarkCollection.marks;
                var srcStartPosition = cfi1.offsetChar.slice();
                var srcEndPosition = cfi2.offsetChar.slice();
                var loadedChapters = DocumentModel.getLoadedChapters();



                _.map(srcStartPosition, function(el, i, arr) {
                    if (!!arr[i + 1] && _.isNumber(arr[i + 1])) {
                        arr[i] = el / 2;
                    }
                    arr[i] = arr[i] - 1;
                });

                _.map(srcEndPosition, function(el, i, arr) {
                    if (!!arr[i + 1] && _.isNumber(arr[i + 1])) {
                        arr[i] = el / 2;
                    }
                    arr[i] = arr[i] - 1;
                });

                var startChapterIndex = srcStartPosition[1];
                var endChapterIndex = srcEndPosition[1];
                var startChapterArrayIndex;
                var startChapter;
                var endChapter;
                var endChapterArrayIndex;

                _.map(loadedChapters, function(el, i) {
                    if (el.index === startChapterIndex) {
                        startChapter = $('div.' + el.style + ' > div:first-child');
                        startChapterArrayIndex = i;
                    }
                    if (el.index === endChapterIndex) {
                        endChapter = $('div.' + el.style + ' > div:first-child');
                        endChapterArrayIndex = i;
                    }
                });

                srcStartPosition[srcStartPosition.length - 3] += 1;
                var collectNoChildElements = function(eContainer, deepness) {
                    var result = [];
                    var posIsLess = function(pos1, pos2) {
                        var i = 0;

                        for (; i < Math.min(pos1.length, pos2.length) - 2 && pos2[i] === pos1[i]; i++) {};

                        if (i === Math.min(pos1.length, pos2.length) - 2) {
                            return false;
                        } else {
                            return pos2[i] > pos1[i];
                        }
                    };

                    if (deepness < srcStartPosition.length - 2) {
                        while (!!eContainer[srcStartPosition[deepness]] && posIsLess(srcStartPosition, srcEndPosition)) {
                            if (!!$(eContainer[srcStartPosition[deepness]]).children().length) {
                                if (deepness === srcStartPosition.length - 3) {
                                    result.push(eContainer[srcStartPosition[deepness]]);
                                } else {
                                    result = result.concat(collectNoChildElements($(eContainer[srcStartPosition[deepness]]).children(), deepness + 1));
                                }
                            } else {
                                result.push(eContainer[srcStartPosition[deepness]]);
                            }
                            srcStartPosition[deepness] += 1;
                            for (var i = deepness + 1; i < srcStartPosition.length - 1; i++) {
                                srcStartPosition[i] = 0;
                            }
                        }
                    }

                    return result;
                };

                return collectNoChildElements(startChapter.children(), 3);
            },

            self.getSelectionObjectOffset = function(windowSelection) {
                var selection = {
                    start_node: windowSelection.anchorNode,
                    end_node: windowSelection.extentNode,
                    start_pointer: ':' + windowSelection.anchorOffset + ')',
                    end_pointer: ':' + windowSelection.extentOffset + ')',
                    pointer_pb: self.getCurrentChapterOffsetObject(),
                    selectionText: windowSelection.selectionText
                };
                var startNode = selection.start_node;
                var endNode = selection.end_node;
                var focusedChapterIndex;

                selection.start_pointer = '/' + (1 + Array.prototype.indexOf.apply(startNode.parentNode.childNodes, [selection.start_node])) + selection.start_pointer;

                for (startNode = startNode.parentNode; !startNode.parentNode.hasAttribute('ng-repeat'); startNode = startNode.parentNode) {
                    selection.start_pointer = '/' + ((1 + Array.prototype.indexOf.apply(startNode.parentNode.children, [startNode])) * 2) + selection.start_pointer;
                }

                selection.end_pointer = '/' + (1 + Array.prototype.indexOf.apply(endNode.parentNode.childNodes, [selection.end_node])) + selection.end_pointer;

                for (endNode = endNode.parentNode; !endNode.parentNode.hasAttribute('ng-repeat'); endNode = endNode.parentNode) {
                    selection.end_pointer = '/' + ((1 + Array.prototype.indexOf.apply(endNode.parentNode.children, [endNode])) * 2) + selection.end_pointer;
                }

                selection.start_pointer = '#epubcfi(/6/' + ((parseInt(startNode.parentNode.getAttribute('chapter-index')) + 1) * 2) + '!/4' + selection.start_pointer;
                selection.end_pointer = '#epubcfi(/6/' + ((parseInt(endNode.parentNode.getAttribute('chapter-index')) + 1) * 2) + '!/4' + selection.end_pointer;
                selection.className = windowSelection.className;

                return selection;
            };

        self.getCurrentFocusedItem = function() {
            var documentInformation = DocumentModel.getDocumentInformation(),
                focusedChapterIndex;

            for (var j = 0; j < documentInformation.length && (_.isUndefined(documentInformation[j].offsetPx) || documentInformation[j].offsetPx >= scrollPosition); j++) {
                if (!_.isUndefined(documentInformation[j].offsetPx)) {
                    focusedChapterIndex = j;
                }
            }!!focusedChapterIndex && (focusedChapterIndex++);

            return focusedChapterIndex || 0;
        };

        self.getCurrentChapterOffsetObjectByFormat = {
            'epub': function() {
                // debugger
                var bookmarkIdCollection;
                var chapterOffsetObject;
                var chapterURL;
                var cfiPosition = '#epubcfi(/6/';
                var focusedChapterIndex = 0;
                var focusedChapterContentInfo;
                var tocContentItems = _.cloneDeep(DocumentModel.getContentItems());
                var currentPercent;

                var documentInformation = DocumentModel.getDocumentInformation();

                for (j = 0; j < documentInformation.length && (_.isUndefined(documentInformation[j].offsetPx) || documentInformation[j].offsetPx >= scrollPosition); j++) {
                    if (!_.isUndefined(documentInformation[j].offsetPx)) {
                        focusedChapterIndex = j;
                    }
                }
                if (focusedChapterIndex < documentInformation.length && focusedChapterIndex > 0) {
                    var chapterComponentOffset = documentInformation[focusedChapterIndex].offsetPx - scrollPosition;
                    var cfiMarks = cfiBookmarks[focusedChapterIndex].marks;

                    cfiPosition += (focusedChapterIndex + 1) * 2 + '!/4';

                    for (; cfiMarks && cfiMarks.length;) {
                        for (var i = 0; cfiMarks.length && i < cfiMarks.length && cfiMarks[i].offsetPx < chapterComponentOffset;) { i++ };
                        cfiPosition += '/' + 2 * i;
                        cfiMarks = cfiMarks[i > 0 ? i - 1 : 0].children;
                    }
                } else if (focusedChapterIndex === 0) {
                    cfiPosition += (focusedChapterIndex + 1) * 2 + '!/4';
                }
                bookmarkIdCollection = _.keys(chaptersBookmarks);

                //collecting toc items into one array
                for (var i = 0; i < tocContentItems.length; i++) {
                    if (tocContentItems[i].items && !!tocContentItems[i].items.length) {
                        //splice subitems into tocContentItems
                        tocContentItems = tocContentItems.concat(tocContentItems[i].items);
                    }
                }
                for (var j = 0; j < bookmarkIdCollection.length && !chapterURL; j++) {
                    var chapterMarksCollection = _.keys(chaptersBookmarks[bookmarkIdCollection[j]].marks);

                    for (var i = 0; i < chapterMarksCollection.length && !chapterOffsetObject; i++) {
                        var offsetObject = chaptersBookmarks[bookmarkIdCollection[j]].marks[chapterMarksCollection[i]];
                        if ((angular.element(offsetObject.element).position().top > -scrollPosition) ||
                            (j === bookmarkIdCollection.length - 1 && angular.element(offsetObject.element).position().top <= -scrollPosition)) {
                            // debugger
                            chapterURL = chaptersBookmarks[bookmarkIdCollection[j]].url;
                            focusedChapterContentInfo = _.filter(tocContentItems, function(el, i) {
                                return el.url === chapterURL;
                            });
                            currentPercent = (100 * self.getCurrentPageNumber() / self.getTotalPagesCount()).toFixed(0);
                            // console.warn('EPUB: currentPercent',currentPercent);
                            // console.warn('EPUB: doc percent',DocumentModel.getDocumentBaseInformation().position.percent );
                            chapterOffsetObject = offsetObject;
                            chapterOffsetObject.offsetChars = chapterMarksCollection[i];
                            chapterOffsetObject.pOffset = angular.element(offsetObject.element).position().top + scrollPosition;
                            chapterOffsetObject.percent = Math.max(currentPercent, DocumentModel.getDocumentBaseInformation().position.percent || 0);
                            chapterOffsetObject.favorite = self.getFavorite();
                            chapterOffsetObject.pointer = cfiPosition + ')';
                            /*chapterOffsetObject.pointer_pb = 'pbr:/word?page=' + self.getCurrentPageNumber() + '?offs=' + chapterOffsetObject.offsetChars + '#' + chapterOffsetObject.pointer*/
                            // was for web-reader precision position only?
                            // chapterOffsetObject.pointer_pb = "pbl:" + chapterOffsetObject.url + '?offs=' + chapterOffsetObject.offsetChars +
                            //     '&pixelsTop=' + chapterOffsetObject.pOffset.toFixed(0);
                            if (!!focusedChapterContentInfo.length) {
                                chapterOffsetObject.chapterTitle = focusedChapterContentInfo[0].title;
                            } else {
                                chapterOffsetObject.chapterTitle = '';
                            }
                            console.warn('EPUB: chapterOffsetObject',chapterOffsetObject);
                        }
                    }
                }

                return chapterOffsetObject;
            },
            'pdf': function() {
                var bookmarkIdCollection;
                var chapterOffsetObject;
                var chapterURL;
                var focusedChapterIndex = 0;
                var focusedChapterContentInfo;
                var tocContentItems = _.cloneDeep(DocumentModel.getContentItems());
                var currentPercent;

                var documentInformation = DocumentModel.getDocumentInformation();

                for (j = 0; j < documentInformation.length && (_.isUndefined(documentInformation[j].offsetPx) || documentInformation[j].offsetPx >= scrollPosition); j++) {
                    if (!_.isUndefined(documentInformation[j].offsetPx)) {
                        focusedChapterIndex = j;
                    }
                }

                bookmarkIdCollection = _.keys(chaptersBookmarks);

                //collecting toc items into one array
                for (var i = 0; i < tocContentItems.length; i++) {
                    if (tocContentItems[i].items && !!tocContentItems[i].items.length) {
                        //splice subitems into tocContentItems
                        tocContentItems = tocContentItems.concat(tocContentItems[i].items);
                    }
                }

                for (var j = 0; j < bookmarkIdCollection.length && !chapterURL; j++) {
                    var chapterMarksCollection = _.keys(chaptersBookmarks[bookmarkIdCollection[j]].marks);

                    for (var i = 0; i < chapterMarksCollection.length && !chapterOffsetObject; i++) {
                        var offsetObject = chaptersBookmarks[bookmarkIdCollection[j]].marks[chapterMarksCollection[i]];

                        if ((angular.element(offsetObject.element).position().top > -scrollPosition) ||
                            (j === bookmarkIdCollection.length - 1 && angular.element(offsetObject.element).position().top <= -scrollPosition)) {
                            chapterURL = chaptersBookmarks[bookmarkIdCollection[j]].url;
                            focusedChapterContentInfo = _.filter(tocContentItems, function(el, i) {
                                return el.url === chapterURL;
                            });
                            currentPercent = (100 * self.getCurrentPageNumber() / self.getTotalPagesCount()).toFixed(0);

                            chapterOffsetObject = offsetObject;
                            chapterOffsetObject.offsetChars = chapterMarksCollection[i];
                            chapterOffsetObject.pOffset = angular.element(offsetObject.element).position().top + scrollPosition;
                            chapterOffsetObject.percent = Math.max(currentPercent, DocumentModel.getDocumentBaseInformation().position.percent || 0);
                            chapterOffsetObject.favorite = self.getFavorite();
                            chapterOffsetObject.pointer = '#pdfloc(0,' + focusedChapterIndex + ')';
                            chapterOffsetObject.pointer_pb = chapterOffsetObject.url + '#' + chapterOffsetObject.pointer
                            // was for web-reader precision position only?
                            // chapterOffsetObject.pointer_pb = 'pbl:/page-' + focusedChapterIndex + '.xml?offs=0&pixelsTop=' + chapterOffsetObject.pOffset;

                            if (!!focusedChapterContentInfo.length) {
                                chapterOffsetObject.chapterTitle = focusedChapterContentInfo[0].title;
                            } else {
                                chapterOffsetObject.chapterTitle = '';
                            }
                        }
                    }
                }
                // console.warn('PDF: chapterOffsetObject',chapterOffsetObject);
                return chapterOffsetObject;
            }
        };
        self.getCurrentChapterOffsetObject = function() {
    //TODO get offset of chapter and scroll to it soon
            return self.getCurrentChapterOffsetObjectByFormat[DocumentModel.getDocumentFormat()]();
        };

        self.updateBookOffset = function(newValue) {
            localStorageService.set(cookieStore.get('path') + '.readPosition', newValue);
        };

        self.updateCurrentBookOffset = function(newValue) {
            currentBookOffset = newValue;
        };

        self.getTotalPagesCount = function() {
            // console.log(pages)
            return pages.total;
        };

        self.getCurrentPageNumber = function() {
            return pages.current;
        }

        self.updatePagesCount = function(newValue) {
            // console.warn('updatePagesCount', newValue);
            pages.total = newValue;
        };

        self.updateCurrentPageNumber = function(newValue) {
            // console.warn('updateCurrentPageNumber', newValue)
            pages.current = newValue;
            self.executeSubscriptions.call(this, onProgressUpdate, { pages: pages });
        };

        self.getFavorite = function() {
            return isFavorite;
        };

        self.updateFavorite = function(newValue) {
            isFavorite = newValue;
        };

        self.changeSpinnerState = function(newBoolValue, hideSpinner) {
            self.executeSubscriptions.call(this, onSpinnerStateChangeRequest, { newValue: newBoolValue, hideSpinner: !!hideSpinner });
        };

        self.subscribe = {
            onDocHeightChange: function(callback) {
                onDocHeightChange.push(callback);
            },
            onDocScrollRequested: function(callback) {
                onDocScrollRequestedCallback.push(callback);
            },
            onChapterRendered: function(chapterIndex, callBackFunction) {
                if (_.isUndefined(onChapterRendered[chapterIndex])) {
                    onChapterRendered[chapterIndex] = [];
                }

                onChapterRendered[chapterIndex].push(callBackFunction);
                return onChapterRendered[chapterIndex].length - 1;
            },
            onColorThemeUpdate: function(callbackFunction) {
                onColorThemeUpdateCallback.push(callback);
            },
            onProgressUpdate: function(callback) {
                onProgressUpdate.push(callback);
            },
            onSpinnerStateChangeRequested: function(callback) {
                onSpinnerStateChangeRequest.push(callback);
            },
            onScrollCreated: function(callback) {
                (statusScrollCreated && self.executeSubscriptions.call(this, [callback], {})) || onStatusScrollCreated.push(callback);
            }
        };

        self.updateStatus = {
            setScrollCreated: function() {
                self.executeSubscriptions.call(this, onStatusScrollCreated, {});
                statusScrollCreated = true;
            }
        };

        self.unsubscribe = {
            onChapterRendered: function(chapterIndex, callbackId) {
                if (!!onChapterRendered[chapterIndex] &&
                    !!onChapterRendered[chapterIndex][callbackId]) {
                    onChapterRendered[chapterIndex][callbackId] = null;
                }
            },
        };

        self.executeSubscriptions = function(callbacks, args) {
            var self = this;
            return _.every(callbacks, function(fn) {
                if (!_.isNull(fn)) {
                    return fn.apply(self, [args]) !== false;
                }
            })
        };

        self.updateScrollPosition = function(newValue) {
            scrollPosition = newValue;
        };

        self.updateChapterBookmarks = function(chapterId, chapterBookmarks) {
            var chapterUrl = DocumentModel.getChapterUrlById(chapterId);

            chaptersBookmarks[chapterId] = {
                marks: chapterBookmarks,
                url: chapterUrl
            };
        };

        self.updateCfiBookmarks = function(chapterId, chapterBookmarks) {
            var chapterUrl = DocumentModel.getChapterUrlById(chapterId);
            cfiBookmarks = cfiBookmarks || {};
            cfiBookmarks[chapterId] = {
                marks: chapterBookmarks,
                url: chapterUrl
            };
        };

        self.updateColorTheme = function(newCssRulesAlias) {
            self.executeSubscriptions.call(this, onColorThemeUpdate, { newCssRulesAlias: newCssRulesAlias });
        };

    }
    constructor.$inject = ["HashService", "DocumentModel", "$cookieStore", "$interval", "localStorageService", "$timeout"];

}();